import { render, staticRenderFns } from "./c-barrage.vue?vue&type=template&id=02c602fa&scoped=true&"
import script from "./c-barrage.vue?vue&type=script&lang=js&"
export * from "./c-barrage.vue?vue&type=script&lang=js&"
import style0 from "./c-barrage.vue?vue&type=style&index=0&id=02c602fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c602fa",
  null
  
)

export default component.exports